import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import fi from './fi';
import en from './en';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translation'],
  debug: import.meta.env.DEV,
  // react i18next special options (optional)
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  react: {
    useSuspense: true,
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    nsMode: 'default',
  },
  resources: {
    en,
    // TODO: Reenable Finnish language once supported
    // fi,
  },
});

export default i18n;
